module.exports = __webpack_public_path__ + "media/xiaoman_06_超级好玩.cc8c7ee6.wav";